export default [
  {
    title: '设备名称',
    dataIndex: 'deviceName',
    key: 'deviceName'
  },
  {
    title: '所属机构',
    dataIndex: 'deptFullName',
    key: 'deptFullName'
  },
  {
    title: '云服务到期时间',
    dataIndex: 'cloudPlatformExpiredAt',
    key: 'cloudPlatformExpiredAt'
  },
  {
    title: '物联网卡到期时间',
    dataIndex: 'iotCardExpiredAt',
    key: 'iotCardExpiredAt'
  }
]
